<a class="block block-bordered block-link-underline">
  <div class="block-content block-content-full clearfix" >
    <div class="float-right company-right-block pt-5" >
      <ng-content select="[company-block-logo]"></ng-content>
    </div>
    <div class="float-left text-left company-left-block"  >
      <div class="font-w600  mt-10 mb-5">
        <ng-content select="[company-name]"></ng-content>
      </div>
      <div class="font-size-sm text-muted ">
        <ng-content select="[company-summary]"></ng-content>
      </div>
    </div>
  </div>
</a>



// WEBPACK FOOTER //
// ./client/app/shared/blocks/company-block/company-block.component.html